import { supabase } from "./supabase";
import { config } from "./config";

export const OAUTH_MSG = "rmm-oauth";
export const OAUTH_ERR = "rmm-oauth-error";

export const isStaffRole = (r) => r === "admin" || r === "sub_admin";
export const homeForRole = (r) => (isStaffRole(r) ? "/admin" : "/portal");

// Calls the Turnstile-protected Edge Function; applies the returned session.
export async function secureAuth(action, body) {
  const res = await fetch(`${config.supabaseUrl}/functions/v1/secure-auth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: config.supabaseAnonKey,
      Authorization: `Bearer ${config.supabaseAnonKey}`,
    },
    body: JSON.stringify({ action, ...body }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || "Something went wrong. Please try again.");
  if (data.session) {
    const { error } = await supabase.auth.setSession(data.session);
    if (error) throw error;
  }
  return data;
}
